module.exports = __webpack_public_path__ + "media/images/about-us/works/Submit_Request-6abe3176ac50f6d3ed0147f6d315a1b5.png";